export default __webpack_public_path__ + "static/product1-ccb1fd0e17d7cf079d252ba26205a7c7.png";